<template>
  <v-row justify="center" align="center" class="pt-4" v-if="loading">
    <v-progress-circular :size="70" color="#5c648b" indeterminate />
  </v-row>
  <div v-else>
    <v-container>
      <v-row class="ma-0">
        <v-col cols="12" align="left" class="resource-type pa-0">
          {{ resourceDetails.resource_type.name }}
        </v-col>
        <v-col cols="12" align="left" class="resource-title pa-0">
          {{ resourceDetails.title }}
        </v-col>
        <v-col cols="12" class="px-0">
          <v-row class="ma-0">
            <v-rating
              color="#FFA425"
              empty-icon="$ratingFull"
              background-color="#C2D1D9"
              half-increments
              :value="parseFloat(resourceDetails.average_rating)"
              hover
              dense
              size="24"
              readonly
            />
            <div class="rating-count ms-2">
              ({{ resourceDetails.ratings_count }} Ratings)
            </div>
            <!-- {{ resourceDetails.average_rating }} {{ resourceDetails.ratings_count }} -->
          </v-row>
        </v-col>
      </v-row>

      <!-- <iframe
        src="https://research.google.com/pubs/archive/44678.pdf"
        width="100%"
        height="100%"
      /> -->
      <v-col align="right">
        <v-btn color="#506CFF" dark small @click="downloadFile">
          <span class="btn-text">
            Download
            <v-icon color="#FFFFFF" size="20">
              mdi-download-circle-outline
            </v-icon>
          </span>
        </v-btn>
      </v-col>
      <v-row
        justify="center"
        align="center"
        class="ma-0 mt-8"
        style="height:80vh"
      >
        <iframe
          v-if="selectedFile.file_type == 'PDF'"
          :src="selectedFile.file_path + '#toolbar=0'"
          id="Iframe"
          frameborder="0"
          width="100%"
          height="100%"
          allowtransparency="true"
        >
        </iframe>
        <v-img
          height="100%"
          v-else-if="selectedFile.file_type == 'IMAGE'"
          :src="selectedFile.file_path"
          lazy-src="/image-placeholder.png"
          aspect-ratio="1.75"
          contain
          style="border-radius: 6px;"
          :alt="selectedFile.file_name"
        />
        <iframe
          v-else
          :src="
            'https://docs.google.com/viewer?url=' +
              selectedFile.file_path +
              '&embedded=true'
          "
          frameborder="0"
          width="100%"
          height="100%"
        />

        <!-- <embed
          src="https://research.google.com/pubs/archive/44678.pdf"
          width="100%"
          height="1280px"
        /> -->
      </v-row>

      <ShareSection
        v-if="resourceDetails.resource_files.length > 0"
        :resourceDetails="resourceDetails"
        :properties="getEventProperties({})"
      />
      <v-row justify="center" align="center" class="ma-0 mt-8">
        <RateNowSection
          :resourceDetails="resourceDetails"
          :properties="getEventProperties({})"
        />
      </v-row>

      <v-col align="center" v-if="resourceDetails.resource_files.length > 1">
        <v-col class="main-heading">
          Other Files Avaliable for this Resource
        </v-col>
        <v-col>
          <v-row
            v-for="(file, index) in resourceDetails.resource_files"
            :key="index"
            class="ma-0 mt-4"
            align="center"
            justify="center"
            style="max-width: 720px;"
          >
            <div class="file-name">
              File {{ index + 1 }} :
              {{ file.file_name }}
            </div>

            <v-spacer />

            <v-btn
              color="#506CFF"
              dark
              text
              style="border-bottom: 1px solid #506CFF; border-radius: 0px;"
              small
              @click="setSelectedFile(file)"
            >
              <span class="btn-text">
                View Now
              </span>
            </v-btn>
          </v-row>
        </v-col>
      </v-col>
    </v-container>
  </div>
</template>

<script>
  import Keys from "../../../../../constants/keys";
  import Axios from "../../../../../api/BaseAxios";
  import { API_CLIENT_URL } from "../../../../../constants/urls";

  import ShareSection from "../../../../../components/Resources/Details/ShareSection";
  import RateNowSection from "../../../../../components/Resources/Details/RateNowSection";

  export default {
    name: "ResourceFiles",
    components: {
      ShareSection,
      RateNowSection,
    },
    data() {
      return {
        loading: true,
        resourceDetails: null,
        selectedFile: null,
      };
    },
    created() {
      this.getResourceDetails();
    },
    computed: {},
    watch: {},
    methods: {
      getResourceDetails() {
        var self = this;

        self.loading = true;

        const successHandler = (res) => {
          if (!self.selectedFile)
            self.selectedFile = res.data.data.resource_files[0];

          self.loading = false;
          self.resourceDetails = res.data.data;
          //   AmplitudeHelper.registerAmplitudeEvent(
          //     "view resource detail page",
          //     self.getEventProperties({})
          //   );
        };

        const failureHandler = (res) => {
          console.log(res);
          self.loading = false;
        };

        let requestParams = {};
        requestParams[Keys.ID] = this.$route.params.id;

        Axios.request_GET(
          API_CLIENT_URL.resourceDetails,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      },
      getEventProperties(properties) {
        properties["resource name"] = this.resourceDetails.title;
        properties["resource type"] = this.resourceDetails.resource_type.name;

        properties["tags"] = [
          ...new Set(this.resourceDetails.tags.map((element) => element.name)),
        ];
        properties["skills"] = [
          ...new Set(
            this.resourceDetails.skills.map((element) => element.name)
          ),
        ];
        properties["age group"] = [
          ...new Set(
            this.resourceDetails.age_groups.map((element) => element.name)
          ),
        ];
        return properties;
      },
      setSelectedFile(file) {
        this.selectedFile = file;

        // document.getElementById("Iframe").contentWindow.location.reload();
        // this.$forceUpdate();
      },
      downloadFile() {
        // window.open(url, "Download");
        var anchor = document.createElement("a");
        var fileName = this.selectedFile.file_path.split("/").pop();
        anchor.href = this.selectedFile.file_path;
        anchor.target = "_blank";
        anchor.download = fileName;
        anchor.click();
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .resource-type {
    font-weight: 900;
    font-size: 21px;
    line-height: 32px;
    color: #506cff;
  }
  .resource-title {
    font-weight: 900;
    font-size: 30px;
    line-height: 42px;
    color: #333333;
  }
  .rating-count {
    font-weight: 900;
    font-size: 18px;
    line-height: 27px;
    color: rgba(51, 51, 51, 0.7);
  }

  .main-heading {
    font-weight: 900;
    font-size: 24px;
    line-height: 36px;
    color: #333333;
  }
  .file-name {
    font-weight: 900;
    font-size: 18px;
    line-height: 27px;
    color: #333333;
  }
  .btn-text {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
  }

  .btn-width {
    width: 260px;
  }

  .textarea {
    background: #f5f5f5;
    border-radius: 5px;
  }
</style>
